import { useEffect } from 'react';
import {
    getOrCreateGtag,
    getTrackingWindow,
    injectHeadScript,
} from '../util/inject-head-script';

interface GA4Props {
    id: string;
}

export const GA4Head: React.FC<GA4Props> = ({ id }) => {
    // gtag is injected after hydration (see `injectHeadScript`); a gtag/js + inline
    // config in <head> would run during parse and break document hydration.
    useEffect(() => {
        const w = getTrackingWindow();
        const gtag = getOrCreateGtag(w);
        gtag('js', new Date());
        gtag('config', id);
        injectHeadScript(`https://www.googletagmanager.com/gtag/js?id=${id}`);
    }, [id]);

    return null;
};
